// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1DDFo","title":"card_title__3acYD","inActive":"card_inActive__1bP_1"};